import React from "react";
import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid } from "recharts";

const TrendChart = ({ title, data, color = "#3b68ff" }) => (
  <div className="panel">
    <div className="card-title" style={{ marginBottom: 8 }}>
      {title}
    </div>
    <ResponsiveContainer width="100%" height={260}>
      <LineChart data={data}>
        <CartesianGrid stroke="#1f2a44" strokeDasharray="3 3" />
        <XAxis dataKey="period" stroke="#8fa1c7" />
        <YAxis stroke="#8fa1c7" />
        <Tooltip
          contentStyle={{ background: "#0f182b", border: "1px solid #1f2a44", borderRadius: 10 }}
          labelStyle={{ color: "#e8ecf5" }}
        />
        <Line type="monotone" dataKey="value" stroke={color} strokeWidth={3} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  </div>
);

export default TrendChart;
